module.exports = __webpack_public_path__ + "static/media/083-somalia.02e3fb5a.svg";